<div class="periodo-selector">
  <button *ngFor="let p of periodos"
          type="button"
          class="periodo-btn"
          [class.ativo]="selecionado === p.valor"
          [disabled]="disabled"
          (click)="selecionar(p.valor)">
    {{ p.label }}
  </button>
</div>
